export default __webpack_public_path__ + "static/realWorldImg4-d3e1d624dcaa28e0668ca125312ea8bc.webp";